import {Constants} from './trialPeriodReportConstants'
import {TrialPeriodReport} from '../../../model/trialPeriodReport.model'


export function addTrialPeriodReport(report: TrialPeriodReport) {
	return {
		type: Constants.ADD_TRIAL_PERIOD_REPORT,
		payload: report
	} as const
}

export function updateTrialPeriodReport(report: TrialPeriodReport) {
	return {
		type: Constants.UPDATE_TRIAL_PERIOD_REPORT,
		payload: report
	} as const
}

export function removeTrialPeriodReport(id: number) {
	return {
		type: Constants.REMOVE_TRIAL_PERIOD_REPORT,
		payload: id
	} as const
}